// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pfng","footer":"styles_footer__2TdOr"};